import type { ShaderMaterial } from 'three';
import type { PaletteModel } from '../../../../data/types';
import type { Rng } from '../../../../core/rng';
import { buildNearDetailLod, type NearDetailLod, type NearDetailSet } from '../../../mesh/nearDetailLod';
import { buildTraceryTemplates } from './traceryTemplates';
import type { TraceryKind } from './traceryLayout';

/**
 * The detail programme's near tier (PLAN, 2026-09-27): the tracery is drawn within 60 m of the
 * camera. Farther off its ribs thin below a pixel and would shimmer, and the painterly filter wipes
 * them out; the painter's view shows none.
 */
export const LANDMARK_TRACERY = { name: 'landmark-tracery', radius: 60 } as const;

/** One instanced mesh per kind of tracery, in the instanced painted material. */
export function buildLandmarkTracery(
  sets: readonly NearDetailSet<TraceryKind>[],
  palette: PaletteModel,
  material: ShaderMaterial,
  rng: Rng
): NearDetailLod {
  return buildNearDetailLod(sets, buildTraceryTemplates(palette, rng), material, LANDMARK_TRACERY);
}
